<template>
  <svg
    v-if="variant === 4"
    class="app-loading-screen__asset"
    width="135.999"
    height="135.031"
    viewBox="0 0 135.999 135.031"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
    data-testid="app-loading-screen__trail-4"
  >
    <path
      d="M129.173 80.6207V92.6861V104.752C129.173 117.705 118.589 128.206 105.532 128.206H30.4664C17.4099 128.206 6.8255 117.705 6.8255 104.752V30.2794C6.8255 17.3262 17.4099 6.8255 30.4664 6.8255H105.532C118.589 6.8255 129.173 17.3262 129.173 30.2794V52.7178"
      pathLength="1"
      stroke="#BFE0FF"
      stroke-width="13.651"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="variant === 3"
    class="app-loading-screen__asset"
    width="133.551"
    height="132.583"
    viewBox="0 0 133.551 132.583"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
    data-testid="app-loading-screen__trail-3"
  >
    <path
      d="M127.949 79.3967V91.4621V103.528C127.949 116.481 117.365 126.982 104.308 126.982H29.2424C16.1859 126.982 5.6015 116.481 5.6015 103.528V29.0554C5.6015 16.1022 16.1859 5.6015 29.2424 5.6015H104.308C117.365 5.6015 127.949 16.1022 127.949 29.0554V51.4938"
      pathLength="1"
      stroke="#8CC5FF"
      stroke-width="11.203"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="variant === 2"
    class="app-loading-screen__asset"
    width="131.613"
    height="130.645"
    viewBox="0 0 131.613 130.645"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
    data-testid="app-loading-screen__trail-2"
  >
    <path
      d="M126.98 78.4277V90.4931V102.559C126.98 115.512 116.396 126.013 103.339 126.013H28.2734C15.2169 126.013 4.6325 115.512 4.6325 102.559V28.0864C4.6325 15.1332 15.2169 4.6325 28.2734 4.6325H103.339C116.396 4.6325 126.98 15.1332 126.98 28.0864V50.5248"
      pathLength="1"
      stroke="#4DA1FE"
      stroke-width="9.265"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="variant === 1"
    class="app-loading-screen__asset"
    width="129.165"
    height="128.197"
    viewBox="0 0 129.165 128.197"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
    data-testid="app-loading-screen__trail-1"
  >
    <path
      d="M125.756 77.2037V89.2691V101.335C125.756 114.288 115.172 124.789 102.115 124.789H27.0494C13.9929 124.789 3.4085 114.288 3.4085 101.335V26.8624C3.4085 13.9092 13.9929 3.4085 27.0494 3.4085H102.115C115.172 3.4085 125.756 13.9092 125.756 26.8624V49.3008"
      pathLength="1"
      stroke="#008CFF"
      stroke-width="6.817"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LoadingTrail',
  props: {
    variant: {
      type: Number,
      required: true,
    },
  },
};
</script>
